<style lang="less">
  // @import '../flow.less';
  @import '../base.less';
</style>

<template>
    <div class="content">
      <div class="main">
          <div>
              <Row>
                  <Col span="24" :md="15">
                      <Row class="title">
                          <h4>Git工作流详情</h4>
                      </Row>
                      <div class="info-property">
                          <dl>
                              <dt>项目</dt><dd>{{detail.project}}</dd>
                          </dl>
                          <dl>
                              <dt>提交ID</dt><dd>
                                <a :href="commitUrl" target="_blank" >
                                  {{ detail.commit }}
                                </a>
                              </dd>
                          </dl>
                          <dl>
                              <dt>申请人</dt><dd>{{detail.user}}</dd>
                          </dl>
                          <dl>
                              <dt>状态</dt><dd>{{detail.status_verbose}}</dd>
                          </dl>
                          <dl>
                              <dt>发布分支</dt><dd>{{detail.branch}}</dd>
                          </dl>
                          <dl>
                              <dt>描述</dt><dd>{{detail.description}}</dd>
                          </dl>
                          <dl>
                              <dt>申请时间</dt><dd>{{detail.time_start}}</dd>
                          </dl>
                          <dl>
                              <dt>完成时间</dt><dd>{{detail.time_end ? detail.time_end : '---'}}</dd>
                          </dl>
                      </div>
                      <Row className="margin-top-10">
                              <Row class="title">
                                  <h4>审批</h4>
                              </Row>
                              <Approves :approves = "detail.approves" approveType = "gitflow" :reFresh= "this.handleReFresh" :status = "detail.status"/>
                      </Row>
                      <Divider orientation="left"></Divider>
                      <Row className="margin-top-10" v-show="isBuildStepShow">
                         <Row class="title">
                           <h4>构建步骤</h4>
                         </Row>
                        <Steps :current="currentStep" >
                           <Step title="" content="构建部署项目测试环境" v-show="isTestShow"><Button type="primary" :loading="loading_test" @click="buildTest" :disabled="disabled_test">
                            <span v-if="!loading_test">构建测试环境</span>
                            <span v-else>构建中...</span></Button>
                          </Step>
                          <Step title="" content="合并当前发布分支到Master分支"><Button type="primary" :loading="loading_merge"  @click="mergeRequest" :disabled="disabled_merge">
                            <span v-if="!loading_merge">合并请求</span>
                            <span v-else>合并请求中...</span></Button>
                          </Step>
                          <Step title="" content="构建部署项目正式环境"><Button type="primary" :loading="loading_product" @click="buildProduct" :disabled="disabled_product">
                            <span v-if="!loading_product">构建正式环境</span>
                            <span v-else>构建中...</span></Button>
                            </Button></Step>
                        </Steps>
                      </Row>
                   </Col>
                   <Col span="24" :md="{ span: 7, offset: 1 }">
                      <div class="title" >
                          <h4>日志信息</h4>
                      </div>
                      <FlowLogs :logs = "detail.logs" />
                  </Col>
              </Row>
            </div>
      </div>
  </div>
</template>
<script>
import { getGitFlowDetail, buildGitFlow, mergeGitFlow } from '@/api/gitflow'
import Approves from '../base/Approves'
import FlowLogs from '../base/Logs'
export default {
  name: 'GitFlowDetail',
  components: {
    'Approves': Approves,
    'FlowLogs': FlowLogs
  },
  data () {
    return {
      detail: {},
      commitUrl: '',
      isTestShow: true,
      loading_merge: false,
      loading_test: false,
      loading_product: false,
      isBuildStepShow: true,
      disabled_merge: false,
      disabled_test: false,
      disabled_product: false,
      currentStep: 0
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      this.getGitFlowDetail(this.$route.query.id)
    }
  },
  methods: {
    getGitFlowDetail (id) {
      this.currentStep = 0
      let params = {
        id: id
      }
      getGitFlowDetail(params).then(res => {
        this.detail = res.data
        this.commitUrl = this.detail.code_url + '/commit/' + this.detail.commit
        // 控制构建步骤是否可见  agree , 状态可以见 ，构建失败是否加进去？
        // if (this.detail.status === 'agree') {
        //   this.isBuildStepShow = true
        //   if (this.detail.need_test === true) {
        //     this.isTestShow = true
        //   }
        // } else {
        //   this.isBuildStepShow = false
        // }
        // 项目是否已经构建 （正式 or  测试 ？）
        if (this.detail.builded) {
          this.disabled_merge = true
          this.disabled_test = true
          this.disabled_product = true
          this.currentStep = 2
        }
        // 项目是否已经 合并过分支
        if (this.detail.merged) {
          this.disabled_merge = true
          this.disabled_test = true
          this.currentStep = 2
        }
        // 控制各构建步骤按钮 当前登录人 是否可点击
        if (this.detail.can_merge) {
          this.disabled_merge = false
        } else {
          this.disabled_merge = true
        }
        if (this.detail.can_build_test && this.detail.need_test) {
          this.disabled_test = false
        } else {
          this.disabled_test = true
        }
        if (this.detail.can_build_product) {
          this.disabled_product = false
        } else {
          this.disabled_product = true
        }
        if (['error', 'cancel', 'fail'].indexOf(this.detail.status) >= 0) {
          this.disabled_merge = true
          this.disabled_test = true
          this.disabled_product = true
        }
      })
    },
    handleReFresh () {
      // 处理刷新操作
      this.getGitFlowDetail(this.$route.query.id)
    },
    mergeRequest () {
      this.loading_merge = true
      this.do_merge_request(this.detail.id)
    },
    buildTest () {
      this.loading_test = true
      this.do_build_request(this.detail.id, 'test')
    },
    buildProduct () {
      this.loading_product = true
      this.do_build_request(this.detail.id, 'product')
    },
    // 发起构建请求
    do_build_request (id, scene) {
      buildGitFlow(id, scene).then(res => {
        if (res.status === 200) {
          // 不管成功失败 界面刷新，loading 状态关闭
          this.$Message.success(res.data.message)
          setTimeout(() => {
            if (scene === 'test') {
              this.loading_test = false
              this.disabled_test = true
              this.currentStep = 1
            } else {
              this.loading_product = false
              this.disabled_product = true
            }
          }, 8000)
        } else if (res.data.status === 502) {
          this.$Message.error('构建超时,请重新构建')
        } else {
          this.$Message.error(res.data.message)
        }
        this.getGitFlowDetail(this.$route.query.id)
      })
    },
    // 发起合并请求
    do_merge_request (id) {
      mergeGitFlow(id).then(res => {
        if (res.data.create.success) {
          this.currentStep = 2
          this.$Message.success(res.data.create.message)
        } else {
          this.$Message.error(res.data.create.message)
        }
        // 不管成功失败 界面刷新，loading 状态关闭
        this.loading_merge = false
        this.getGitFlowDetail(this.$route.query.id)
      })
    }
  },
  mounted: function () {
    this.getGitFlowDetail(this.$route.query.id)
  }
}
</script>
